module.exports = __webpack_public_path__ + "img/Himbeeren.fda5a606.jpg";